import React from 'react';

import Navbar from '../../global/Navbar';
import Footer from '../../global/Footer';
import Newsletter from '../../global/Newsletter';

import Hero from './Hero';
import BIReportExperience from './BIReportExperience';
import ProductOverview from './ProductOverview';
import AnalyticsAndAI from './AnalyticsAndAI';
import CoreCapabilities from './CoreCapabilities';
import HrisParity from './HrisParity';
import TechnicalFoundation from './TechnicalFoundation';
import ConversationStory from './ConversationStory';
import ProductMediaShowcase from './ProductMediaShowcase';
import MetricsCatalogHighlight from './MetricsCatalogHighlight';
import WhyDifferent from './WhyDifferent';
import TrustAndDemo from './TrustAndDemo';
import Faq from './Faq';
import ClosingCTA from './ClosingCTA';

import DeliveryBand from '../../shared/DeliveryBand';
import SectionSurface, { PageFlow } from '../../shared/SectionSurface';
import PageMeta from '../../shared/PageMeta';

function SemanticHR() {
  return (
    <div className="min-w-0 max-w-full">
      <PageMeta path="/semantic-hr" />
      <Navbar />
      <PageFlow>
        <SectionSurface
          variant="hero-premium"
          decor="flow-strong"
          underNav
          bleed="bottom"
          flowBottom
          overlap
        >
          <Hero />
        </SectionSurface>

        <SectionSurface variant="wash" decor="grid" bleed="both" flowTop flowBottom overlap>
          <ProductOverview />
        </SectionSurface>

        <BIReportExperience />

        <SectionSurface variant="subtle" decor="contour" bleed="both" flowTop flowBottom overlap>
          <AnalyticsAndAI />
        </SectionSurface>

        <SectionSurface variant="dots" decor="mesh" bleed="both" flowTop flowBottom overlap>
          <CoreCapabilities />
        </SectionSurface>

        <SectionSurface variant="accent-semantic" decor="contour" bleed="both" flowTop flowBottom overlap>
          <HrisParity />
        </SectionSurface>

        <SectionSurface variant="muted" decor="flow" bleed="both" flowTop flowBottom overlap>
          <TechnicalFoundation />
        </SectionSurface>

        <SectionSurface variant="geometric" decor="mesh" bleed="both" flowTop flowBottom overlap>
          <ProductMediaShowcase />
        </SectionSurface>

        <SectionSurface variant="flow-purple" decor="nodes" bleed="both" flowTop flowBottom overlap>
          <ConversationStory />
        </SectionSurface>

        <SectionSurface variant="diagonal" bleed="both" flowTop flowBottom overlap>
          <MetricsCatalogHighlight />
        </SectionSurface>

        <SectionSurface variant="elevated" bleed="both" flowTop flowBottom overlap>
          <WhyDifferent />
        </SectionSurface>

        <SectionSurface variant="subtle" decor="wave" bleed="both" flowTop flowBottom overlap>
          <TrustAndDemo />
        </SectionSurface>

        <SectionSurface variant="wash" decor="rings" bleed="both" flowTop flowBottom overlap>
          <Faq />
        </SectionSurface>

        <DeliveryBand id="delivery" compact variant="muted" decor="dots" />

        <SectionSurface variant="wave-accent" decor="flow" bleed="both" flowTop overlap>
          <ClosingCTA />
        </SectionSurface>
      </PageFlow>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default SemanticHR;
